import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledLink = styled(({ to, ...props }) => {
  if (to.startsWith('http')) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...props} href={to} />;
  }

  return <Link to={to} {...props} />;
})`
  display: inline-block;
  width: 140px;
  line-height: 0;
  outline: 0;
  padding: 8px;
  margin: -8px;
  border-radius: 3px;

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }
`;

export const StyledLogo = styled.img`

`;
